export enum ActionType {
    SET_LANG_VALUE = "setLangValue",
    SET_NAME = "setName",
    SET_FREEZ_SCREEN = "setFreezScreen",
    SET_ALERT_MESSAGE = "setAlertMessages",
    SET_FORMDATA = "setFormData",
    SET_SHOP_URL = "setShopUrl",
    SET_USER_INFO = "setUserInfo",

    

}